import React from 'react';
import { IconButton } from '@atlaskit/button/new';
import SignInIcon from '@atlaskit/icon/glyph/sign-in';
import SignOutIcon from '@atlaskit/icon/glyph/sign-out';
import { useIntl } from '@atlassian/jira-intl';
import { usePathParam } from '@atlassian/jira-router';
import { toItsmPractice, type ItsmPractice } from '@atlassian/jira-servicedesk-work-category';
import { usePoppedOutState } from '../../controllers/popped-out-state';
import { messages } from './messages';

type PopoutToggleButtonProps = {
	projectKey: string;
	practice: ItsmPractice;
};

export const PopoutToggleButton = ({ projectKey, practice }: PopoutToggleButtonProps) => {
	const [isPoppedOut, { updatePoppedOutState }] = usePoppedOutState(`${projectKey}-${practice}`);
	const [projectKeyFromPath] = usePathParam('projectKey');
	const [practiceFromPath] = usePathParam('practiceType');
	const categoryFromPath = toItsmPractice(practiceFromPath);

	const { formatMessage } = useIntl();

	const handleToggle = () => {
		updatePoppedOutState(projectKey, practice, !isPoppedOut);
	};

	if (projectKey !== projectKeyFromPath || practice !== categoryFromPath) {
		return null;
	}

	if (isPoppedOut) {
		return (
			<IconButton
				label={formatMessage(messages.popInLabel)}
				onClick={handleToggle}
				icon={SignOutIcon}
				spacing="compact"
				appearance="subtle"
			/>
		);
	}

	return (
		<IconButton
			label={formatMessage(messages.popOutLabel)}
			onClick={handleToggle}
			icon={SignInIcon}
			spacing="compact"
			appearance="subtle"
		/>
	);
};
